// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  /* 設置頁面內容與 header bar 的間距，確保 header bar 不會覆蓋頁面內容 */
  /*padding-top: 60px;*/ /* 請根據你的 header bar 高度調整這個數值 */
}

.app-logo {
  /* 固定位置的樣式 */
  position: fixed;
  top: 0;
  left: 5%;
  right: 0;
  z-index: 10000;
  padding: 7px 0;
}

.logo-align {
  /* 將文字置中 */
  display: flex;
  align-items: center;
  /*justify-content: center;*/
}

.top-nav {
  /* 固定位置的樣式 */
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 60px; /* 設置 top nav 的高度 */
  z-index: 1000;
  /*background-color: #f1f1f1; */ /* 請選擇你想要的 top nav 背景顏色 */
  /* 其他樣式，如邊框、陰影等 */
  /*padding: 0px 100px;*/
}

.nav-text {
  /* 將文字置中 */
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.nav-text a {
  float: left;
  display: block;
  color: white;
  text-align: center;
  padding: 14px 32px;
  margin: 0 10px;
  text-decoration: none;
  font-size: 18px;
  font-weight: bold;
}

.nav-text1 {
  /* 將文字置中 */
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.nav-text1 a {
  float: left;
  display: block;
  text-align: center;
  padding: 0px 16px;
  text-decoration: none;
  color: #757679
}

/* 可以進一步美化 logo 圖片和文字樣式 */
.logo-and-text img {
  /*max-height: 50%;*/
  /* 添加其他圖片樣式 */
}

.logo-and-text {
  /* 使用 flex 佈局來水平排列內容 */
  display: flex;
  align-items: center; /* 將內容垂直居中 */
}

/* FullScreenVideo.css */
.fullscreen-video {
  /*position: fixed;*/
  /*top: 0;*/
  /*left: 0;*/
  position: relative;
  /*width: 100vw;*/
  height: 100vh;
  overflow: hidden;
}

.fullscreen-video video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2); /* 半透明的黑色遮罩 */
}

.video-overlay2 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2); /* 半透明的黑色遮罩 */
}

.video-overlay3 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2); /* 半透明的黑色遮罩 */
}

.video-overlay-text1 {
  position: absolute;
  top: 20%;
  width: 100%;
  height: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.video-overlay-text7 {
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -50%); 
  width: 80%;
  height: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.video-overlay-text2 {
  position: absolute;
  top: 70%;
  width: 100%;
  height: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.video-overlay-text2fix {
  position: absolute;
  top: 40%;
  width: 100%;
  height: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.video-overlay-text2fixfix {
  position: relative;
  text-align: center;
  margin: 0 auto;
  img {
    width: 52%;
  }
  @media (max-width: 768px) {
    img {
      width: 88%;
    }
  }
}

.text-shadow {
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}


.video-overlay-text6 {
  position: absolute;
  top: 70%;
  width: 100%;
  height: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.video-overlay-text3 {
  position: absolute;
  top: 20%;
  left: 65%;
  width: 350px;
  height: 20%;
  /*display: flex;
  justify-content: center;
  align-items: center;*/
  color: white;
}

.video-overlay-text3fix {
  position: absolute;
  text-align: center;
  top: 20%;
  left: 65%;
  width: 350px;
  height: 20%;
  /*display: flex;
  justify-content: center;
  align-items: center;*/
  color: white;
}

.video-overlay-text5 {
  position: absolute;
  top: 27%;
  left: 65%;
  width: 400px;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.video-overlay-text5fix {
  position: absolute;
  top: 27%;
  left: 65%;
  width: 400px;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.video-overlay-text4 {
  position: absolute;
  top: 10%;
  left: 5%;
  width: 450px;
  height: 20%;
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
  color: white;
}

.webForm {
  display: block;
}

.mobileForm {
  display: none;
}

@media screen and (max-width: 1200px) {
  .video-overlay-text3 {
    left: 50%;
    transform: translate(-50%, -50%); 
  }
  .video-overlay-text5{
    left: 50%;
    transform: translate(-50%, -50%);
    top: 60%;
    width: 350px;
  }
  .video-overlay-text4 {
    top: 15%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
 
  }
}

@media screen and (max-width: 768px) {
  .video-overlay-text6{
    display: block;
    top: 5%
  }
  .video-overlay-text7{
    top: 80%;
    width: 80%
  }
  .certificate {
   padding: 0 32px; 
  }
  .video-overlay3{
    background-color: rgba(0, 0, 0, 0.7);
  }
}





.overlay-text-leftTop {
  position: absolute;
  top: 20%;
  left: 5%;
  width: 100%;
  /*height: 20%;*/
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
  color: white;
}

.overlay-text-leftBottom {
  position: absolute;
  top: 60%;
  left: 7%;
  width: 100%;
  /*height: 20%;*/
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
  color: white;
}

.overlay-text-leftBottom2 {
  position: absolute;
  top: 50%;
  left: 7%;
  width: 100%;
  /*height: 20%;*/
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
  color: white;
}

.overlay-text-leftBottom2_product {
  position: absolute;
  top: 50%;
  left: 7%;
  width: 100%;
  /*height: 20%;*/
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
  color: white;
}

.overlay-text-rightTop {
  position: absolute;
  top: 20%;
  left: 70%;
  width: 25%;
  /*height: 20%;*/
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
  color: white;
}

.overlay-text-rightTop_product {
  position: absolute;
  top: 20%;
  left: 70%;
  width: 25%;
  /*height: 20%;*/
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
  color: white;
}

.overlay-text-rightBottom {
  position: absolute;
  top: 40%;
  left: 65%;
  width: 400px;
  /*height: 20%;*/
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
  color: white;
}

@media screen and (max-width: 1200px) {
  .overlay-text-leftTop{
    left: 50%;
    transform: translate(-50%, -50%);
    width: 350px; 
  }
  .overlay-text-rightBottom {
    top: 60%;
    left: 50%;
    width: 350px;
    transform: translate(-50%, -50%);
  }
}

@media screen and (max-width: 768px) {
  .mobileFontSize{
    font-size: 16px;
  }
  .product01{
    padding: 50px 20px;
  }
  .overlay-text-leftBottom2_product{
    left: 50%;
    transform: translate(-50%, -50%);
    top: 15%;
    width: 80%; 
  }
  .overlay-text-rightTop_product{
    left: 50%;
    transform: translate(-50%, -50%);
    top: 50%;
    width: 80%; 
  }
}

.container1 {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.item {
  flex: 1 1;
  min-width: 300px; /* 設置每個Col的最小寬度 */
  padding: 10px;
  box-sizing: border-box; /* 讓padding不影響元素的寬度 */
}

/* 使用媒體查詢來控制不同屏幕尺寸下的列數 */
@media screen and (max-width: 767px) {
  .item {
    flex-basis: 100%; /* 在小屏幕下每個Col佔滿一行 */
  }
  .ProductCarousel1{
    margin-bottom: 28px;
  }
  .Contact2{
    padding: 32px 0;
  }
  .webForm{
    display: none;
  }
  .mobileForm{
    display: block;
  }
}

@media screen and (min-width: 768px) and (max-width: 1199px) {
  .item {
    flex-basis: 50%; /* 在中屏幕下每個Col佔據一行的一半 */
  }
}

@media screen and (min-width: 768px) {
  .Home1 {
    padding: 150px 0 120px 0;
  }
  .Contact2 {
    padding: 100px 0
  }
}

@media screen and (min-width: 1200px) {
  .container1{
    margin: 150px 0px;
    padding: 0 5%;
  }
  .item {
    flex-basis: 25%; /* 在大屏幕下每個Col佔據一行的三分之一 */
  }
  .Contact1{
    padding: 0 96px 0 0;
  }
}

.fullscreen-bg {
  position: relative;
  /*width: 100vw;*/
  height: 100vh;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.2);
}

.fullscreen-bg2 {
  position: relative;
  /*width: 100vw;*/
  height: 100vh;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.2); /* 半透明的黑色遮罩 */
}

/*.bg-image {
  background-image: url("product/product2.jpg");
  background-size: cover;
  background-position: center;
  height: 75vh; /* 占据屏幕高度的一半 
  display: flex;
  align-items: center;
  justify-content: center;
}*/

/* 設定背景圖片的樣式 */
.fullscreen-bg img {
 /* position: absolute;*/
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* 確保圖片充滿整個容器 */
}

/* 設定上方顯示文字的樣式 */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.2); /* 可以使用透明背景來提高文字可讀性 */
}

.footer {
  background-color: rgb(53, 53, 53);
  padding: 50px 10%;
}


.headbottom {
  height: 36px;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  box-shadow: 2px 2px 4px 4px rgba(0, 0, 0, 0.2);
  background-color: rgba(240, 142, 31, 0.8);
  z-index: 1004;
  text-align: center;
  .totext {
    font-weight: bolder;
    line-height: 36px;
    padding: 0 20px;
    margin: 0 auto;
    font-size: 15px;
    color: white;
  }
}




.item img {
  width: 100%; /* 让图片宽度占满父容器 */
  height: auto; /* 让高度根据宽度自适应，防止图片变形 */
  display: block; /* 移除图片默认的间距，确保图片紧贴容器边缘 */
}

.text-center-container {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  width: 100%; /* 容器宽度，可以根据需要调整 */
  height: 180px; /*容器高度，可以根据需要调整 */
}

.extra-background {
  background-color: rgba(0, 0, 0, 0.8); /* 额外背景的颜色 */
  height: 0; /* 隐藏额外背景 */
  position: fixed;
  /*top: 60px;  这里根据顶部导航栏的高度来调整 */
  left: 0;
  right: 0;
  z-index: 999; /* 确保在顶部导航栏下方但仍在其他内容之上 */
  transition: height 0.3s; /* 添加过渡效果 */
}

.certificate-panel:hover{
background-color: #ECECEB;
}

.certificate h5{
  font-family: 'Noto Sans TC Medium';
}

.certificate a{
  font-size: 12px;
  height: 18px;
  font-family: 'Noto Sans TC Medium';
  text-decoration: none;
}

.certificate a:hover{
  text-decoration: underline;
}

.transparent-button {
  background-color: transparent; /* 設置按鈕的背景色為透明 */
  border: 2px solid #9f9f9f; /* 設置按鈕的邊框 */
  color: #FFFFFF; /* 設置按鈕文字顏色 */
  padding: 3px 20px; /* 設置按鈕的內邊距 */
  font-size: 22px; /* 設置按鈕文字大小 */
  border-radius: 5px; /* 設置按鈕的圓角 */
  cursor: pointer; /* 變更滑鼠游標類型為指示器 */
  width: 300px;
  font-family:'Noto Sans TC Regular';
  z-index: 10000;
}

.Product2 {
  background-color: white;
}

.transparent-button4 {
  background-color: transparent; /* 設置按鈕的背景色為透明 */
  border: 2px solid #9f9f9f; /* 設置按鈕的邊框 */
  color: #FFFFFF; /* 設置按鈕文字顏色 */
  padding: 3px 20px; /* 設置按鈕的內邊距 */
  font-size: 22px; /* 設置按鈕文字大小 */
  border-radius: 5px; /* 設置按鈕的圓角 */
  cursor: pointer; /* 變更滑鼠游標類型為指示器 */
  width: 300px;
  font-family:'Noto Sans TC Regular';
  z-index: 10000;
}

@media screen and (max-width: 768px) {
  .transparent-button{
    width: 300px;
  }
  .transparent-button4{
    width: 180px;
  }
  .text-center-container{
    height: 70px;
    padding: 0 10px;
  }
  .Product2{
    background-color: #ECECEB;
  }
}

/* 鼠標懸停時的效果 */
.transparent-button:hover {
  background-color: #FFFFFF; /* 透明度設為0.2的淺灰色 */
  color: #757679; /* 文字顏色設置為白色 */
}

/* 鼠標懸停時的效果 */
.transparent-button4:hover {
  background-color: #FFFFFF; /* 透明度設為0.2的淺灰色 */
  color: #757679; /* 文字顏色設置為白色 */
}

.transparent-button2 {
  background-color: white; /* 設置按鈕的背景色為透明 */
  border: 2px solid white; /* 設置按鈕的邊框 */
  color: black; /* 設置按鈕文字顏色 */
  padding: 5px 20px; /* 設置按鈕的內邊距 */
  font-size: 14px; /* 設置按鈕文字大小 */
  border-radius: 2px; /* 設置按鈕的圓角 */
  cursor: pointer; /* 變更滑鼠游標類型為指示器 */
  width: 190px;
  font-family:'Noto Sans TC Regular';
  z-index: 10000;
}

.transparent-button3 {
  background-color: transparent; /* 設置按鈕的背景色為透明 */
  border: 2px solid white; /* 設置按鈕的邊框 */
  color: black; /* 設置按鈕文字顏色 */
  padding: 7px 20px; /* 設置按鈕的內邊距 */
  font-size: 14px; /* 設置按鈕文字大小 */
  border-radius: 2px; /* 設置按鈕的圓角 */
  cursor: pointer; /* 變更滑鼠游標類型為指示器 */
  width: 190px;
  font-family:'Noto Sans TC Regular';
  z-index: 10000;
}

.transparent-button3:hover{
  background-color: #FEC30A;
  border-color: #FEC30A;
}

.transparent-button3:focus{
  background-color: #FEC30A;
  border-color: #FEC30A;
}

/* 修改 Carousel 转场按钮（prev 和 next）的颜色 */
.carousel-control-prev,
.carousel-control-next {
  color: #808080; /* 替换为您想要的颜色 */
}

/* 修改 Carousel 指示符（键号）激活状态的颜色 */
.carousel-indicators .active {
  background-color: #808080; /* 替换为您想要的激活状态的颜色 */
}

.english_FontFamily {
  font-family: 'Exo VariableFont wght';
  font-weight: 500;
}

.english_FontFamily2 {
  font-family: 'Orbitron VariableFont wght';
  font-weight: 500;
}

.mobile-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #333; /* 设置背景颜色 */
  color: #fff; /* 设置文字颜色 */
  /*padding: 10px 20px;*/
}

.mobile-nav-icon {
  cursor: pointer;
  font-size: 24px;
}

.mobile-nav-links {
  display: none; /* 初始状态下隐藏导航链接 */
}

@media (max-width: 768px) {
  .mobile-nav-links {
    display: block; /* 在小屏幕下显示导航链接 */
    position: absolute;
    top: 60px; /* 调整展开后的位置 */
    left: 0;
    background-color: #333;
    width: 100%;
    padding: 10px 20px;
  }
}

.header {
  display: none;
}

@media (min-width: 768px) {
  .header {
    display: block; /* 在大于或等于 768px 的屏幕宽度下显示Header */
  }
}

.mobile_header{
  display: none;
}

.showOnMobile {
  display: none;
}

.center_container {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  width: 100%; /* 使容器占据父元素的宽度 */
}

@media (max-width: 768px) {
  .mobile_header {
    display: block; /* 在大于或等于 768px 的屏幕宽度下显示Header */
  }
  .app-logo{
    left: 50%;
    transform: translate(-50%, -50%); 
    top: 28px; 
 }
 .showOnMobile{
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center; /* 垂直居中 */
    width: 100%; /* 使容器占据父元素的宽度 */
    height: 72px;
 }
}

.fixed-Icon {
  position: fixed; /* 固定定位 */
  top: 0; /* 距离顶部的距离为 0 */
  right: 0; /* 距离右侧的距离为 0 */
  font-size: 60px;
  padding: 10px;
  color: white;
}

/* Style for the right drawer container */
.right-drawer {
  position: fixed; /* Fixed position to keep it in view */
  top: 0;
  right: -90%; /* Initially off-screen to the right */
  width: 90%; /* Adjust the width as needed */
  height: 100%; /* Take up the full height of the viewport */
  background-color: #e5e5e5; /* Background color of the drawer */
  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.3); /* Add a shadow for depth */
  transition: right 0.3s ease; /* Smooth transition for opening/closing */
  z-index: 999; /* Ensure it's above other content */
}

/* Style for the button to open the drawer */
.open-drawer-button {
  position: absolute; /* Position it anywhere you like */
  top: 20px;
  right: 20px;
  background-color: #007bff;
  color: #fff;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
}

/* Style for the content inside the drawer */
.drawer-content {
  padding: 20px;
}

/* Class to open the right drawer */
.open {
  right: 0;
}

.submitBtn {
  background-color: #FCB208;
}

.submitBtn:hover {
  background-color: #EFAA00;
}

.contacttext {
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
  max-width: 60%;
  line-height: 1.7;
  text-align: center;
  @media (max-width: 768px) {
    max-width: 88%;
  }
}

.image-company {
  display: none;
  @media (max-width: 768px) {
    display: block;
    img {
      max-width: 100%;
      padding-bottom: 10px;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kDAAkD;EAClD,qBAAqB,EAAE,8BAA8B;AACvD;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,MAAM;EACN,QAAQ;EACR,QAAQ;EACR,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY,EAAE,mBAAmB;EACjC,aAAa;EACb,8BAA8B,EAAE,yBAAyB;EACzD,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB;AACF;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB,EAAE,YAAY;AACnC;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,aAAa;AACrD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,aAAa;AACrD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,aAAa;AACrD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd;IACE,UAAU;EACZ;EACA;IACE;MACE,UAAU;IACZ;EACF;AACF;;AAEA;EACE,2CAA2C;AAC7C;;;AAGA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;EACX;;uBAEqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;EACX;;uBAEqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,SAAS;IACT,gCAAgC;EAClC;EACA;IACE,SAAS;IACT,gCAAgC;IAChC,QAAQ;IACR,YAAY;EACd;EACA;IACE,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAU;;EAEZ;AACF;;AAEA;EACE;IACE,cAAc;IACd;EACF;EACA;IACE,QAAQ;IACR;EACF;EACA;GACC,eAAe;EAChB;EACA;IACE,oCAAoC;EACtC;AACF;;;;;;AAMA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE;IACE,SAAS;IACT,gCAAgC;IAChC,YAAY;EACd;EACA;IACE,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;IACT,gCAAgC;IAChC,QAAQ;IACR,UAAU;EACZ;EACA;IACE,SAAS;IACT,gCAAgC;IAChC,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB,EAAE,iBAAiB;EACnC,aAAa;EACb,sBAAsB,EAAE,qBAAqB;AAC/C;;AAEA,wBAAwB;AACxB;EACE;IACE,gBAAgB,EAAE,mBAAmB;EACvC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe,EAAE,sBAAsB;EACzC;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE;EACF;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,eAAe,EAAE,wBAAwB;EAC3C;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,oCAAoC,EAAE,aAAa;AACrD;;AAEA;;;;;;;;EAQE;;AAEF,cAAc;AACd;CACC,uBAAuB;EACtB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE,eAAe;AACpC;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,oCAAoC,EAAE,qBAAqB;AAC7D;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;;AAGA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,8CAA8C;EAC9C,yCAAyC;EACzC,aAAa;EACb,kBAAkB;EAClB;IACE,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,eAAe;IACf,YAAY;EACd;AACF;;;;;AAKA;EACE,WAAW,EAAE,eAAe;EAC5B,YAAY,EAAE,sBAAsB;EACpC,cAAc,EAAE,yBAAyB;AAC3C;;AAEA;EACE,aAAa;EACb,uBAAuB,EAAE,SAAS;EAClC,mBAAmB,EAAE,SAAS;EAC9B,WAAW,EAAE,kBAAkB;EAC/B,aAAa,EAAE,iBAAiB;AAClC;;AAEA;EACE,oCAAoC,EAAE,YAAY;EAClD,SAAS,EAAE,WAAW;EACtB,eAAe;EACf,+BAA+B;EAC/B,OAAO;EACP,QAAQ;EACR,YAAY,EAAE,wBAAwB;EACtC,uBAAuB,EAAE,WAAW;AACtC;;AAEA;AACA,yBAAyB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B,EAAE,gBAAgB;EAC/C,yBAAyB,EAAE,YAAY;EACvC,cAAc,EAAE,aAAa;EAC7B,iBAAiB,EAAE,aAAa;EAChC,eAAe,EAAE,aAAa;EAC9B,kBAAkB,EAAE,YAAY;EAChC,eAAe,EAAE,iBAAiB;EAClC,YAAY;EACZ,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B,EAAE,gBAAgB;EAC/C,yBAAyB,EAAE,YAAY;EACvC,cAAc,EAAE,aAAa;EAC7B,iBAAiB,EAAE,aAAa;EAChC,eAAe,EAAE,aAAa;EAC9B,kBAAkB,EAAE,YAAY;EAChC,eAAe,EAAE,iBAAiB;EAClC,YAAY;EACZ,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,aAAa;AACb;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,cAAc,EAAE,cAAc;AAChC;;AAEA,aAAa;AACb;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,cAAc,EAAE,cAAc;AAChC;;AAEA;EACE,uBAAuB,EAAE,gBAAgB;EACzC,uBAAuB,EAAE,YAAY;EACrC,YAAY,EAAE,aAAa;EAC3B,iBAAiB,EAAE,aAAa;EAChC,eAAe,EAAE,aAAa;EAC9B,kBAAkB,EAAE,YAAY;EAChC,eAAe,EAAE,iBAAiB;EAClC,YAAY;EACZ,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,6BAA6B,EAAE,gBAAgB;EAC/C,uBAAuB,EAAE,YAAY;EACrC,YAAY,EAAE,aAAa;EAC3B,iBAAiB,EAAE,aAAa;EAChC,eAAe,EAAE,aAAa;EAC9B,kBAAkB,EAAE,YAAY;EAChC,eAAe,EAAE,iBAAiB;EAClC,YAAY;EACZ,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,qCAAqC;AACrC;;EAEE,cAAc,EAAE,cAAc;AAChC;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB,EAAE,mBAAmB;AAChD;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB,EAAE,WAAW;EACnC,WAAW,EAAE,WAAW;EACxB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa,EAAE,gBAAgB;AACjC;;AAEA;EACE;IACE,cAAc,EAAE,gBAAgB;IAChC,kBAAkB;IAClB,SAAS,EAAE,aAAa;IACxB,OAAO;IACP,sBAAsB;IACtB,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc,EAAE,gCAAgC;EAClD;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB,EAAE,SAAS;EAClC,mBAAmB,EAAE,SAAS;EAC9B,WAAW,EAAE,gBAAgB;AAC/B;;AAEA;EACE;IACE,cAAc,EAAE,gCAAgC;EAClD;EACA;IACE,SAAS;IACT,gCAAgC;IAChC,SAAS;CACZ;CACA;IACG,aAAa;IACb,uBAAuB,EAAE,SAAS;IAClC,mBAAmB,EAAE,SAAS;IAC9B,WAAW,EAAE,gBAAgB;IAC7B,YAAY;CACf;AACD;;AAEA;EACE,eAAe,EAAE,SAAS;EAC1B,MAAM,EAAE,eAAe;EACvB,QAAQ,EAAE,eAAe;EACzB,eAAe;EACf,aAAa;EACb,YAAY;AACd;;AAEA,yCAAyC;AACzC;EACE,eAAe,EAAE,sCAAsC;EACvD,MAAM;EACN,WAAW,EAAE,sCAAsC;EACnD,UAAU,EAAE,+BAA+B;EAC3C,YAAY,EAAE,4CAA4C;EAC1D,yBAAyB,EAAE,mCAAmC;EAC9D,0CAA0C,EAAE,2BAA2B;EACvE,2BAA2B,EAAE,0CAA0C;EACvE,YAAY,EAAE,oCAAoC;AACpD;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB,EAAE,kCAAkC;EACtD,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;AACf;;AAEA,mCAAmC;AACnC;EACE,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb;IACE,cAAc;IACd;MACE,eAAe;MACf,oBAAoB;IACtB;EACF;AACF","sourcesContent":["body {\n  /* 設置頁面內容與 header bar 的間距，確保 header bar 不會覆蓋頁面內容 */\n  /*padding-top: 60px;*/ /* 請根據你的 header bar 高度調整這個數值 */\n}\n\n.app-logo {\n  /* 固定位置的樣式 */\n  position: fixed;\n  top: 0;\n  left: 5%;\n  right: 0;\n  z-index: 10000;\n  padding: 7px 0;\n}\n\n.logo-align {\n  /* 將文字置中 */\n  display: flex;\n  align-items: center;\n  /*justify-content: center;*/\n}\n\n.top-nav {\n  /* 固定位置的樣式 */\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 60px; /* 設置 top nav 的高度 */\n  z-index: 1000;\n  /*background-color: #f1f1f1; */ /* 請選擇你想要的 top nav 背景顏色 */\n  /* 其他樣式，如邊框、陰影等 */\n  /*padding: 0px 100px;*/\n}\n\n.nav-text {\n  /* 將文字置中 */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n}\n\n.nav-text a {\n  float: left;\n  display: block;\n  color: white;\n  text-align: center;\n  padding: 14px 32px;\n  margin: 0 10px;\n  text-decoration: none;\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.nav-text1 {\n  /* 將文字置中 */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n}\n\n.nav-text1 a {\n  float: left;\n  display: block;\n  text-align: center;\n  padding: 0px 16px;\n  text-decoration: none;\n  color: #757679\n}\n\n/* 可以進一步美化 logo 圖片和文字樣式 */\n.logo-and-text img {\n  /*max-height: 50%;*/\n  /* 添加其他圖片樣式 */\n}\n\n.logo-and-text {\n  /* 使用 flex 佈局來水平排列內容 */\n  display: flex;\n  align-items: center; /* 將內容垂直居中 */\n}\n\n/* FullScreenVideo.css */\n.fullscreen-video {\n  /*position: fixed;*/\n  /*top: 0;*/\n  /*left: 0;*/\n  position: relative;\n  /*width: 100vw;*/\n  height: 100vh;\n  overflow: hidden;\n}\n\n.fullscreen-video video {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.video-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.2); /* 半透明的黑色遮罩 */\n}\n\n.video-overlay2 {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.2); /* 半透明的黑色遮罩 */\n}\n\n.video-overlay3 {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.2); /* 半透明的黑色遮罩 */\n}\n\n.video-overlay-text1 {\n  position: absolute;\n  top: 20%;\n  width: 100%;\n  height: 20%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n}\n\n.video-overlay-text7 {\n  position: absolute;\n  top: 20%;\n  left: 50%;\n  transform: translate(-50%, -50%); \n  width: 80%;\n  height: 20%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n}\n\n.video-overlay-text2 {\n  position: absolute;\n  top: 70%;\n  width: 100%;\n  height: 20%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n}\n\n.video-overlay-text2fix {\n  position: absolute;\n  top: 40%;\n  width: 100%;\n  height: 20%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n}\n\n.video-overlay-text2fixfix {\n  position: relative;\n  text-align: center;\n  margin: 0 auto;\n  img {\n    width: 52%;\n  }\n  @media (max-width: 768px) {\n    img {\n      width: 88%;\n    }\n  }\n}\n\n.text-shadow {\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n\n.video-overlay-text6 {\n  position: absolute;\n  top: 70%;\n  width: 100%;\n  height: 20%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n}\n\n.video-overlay-text3 {\n  position: absolute;\n  top: 20%;\n  left: 65%;\n  width: 350px;\n  height: 20%;\n  /*display: flex;\n  justify-content: center;\n  align-items: center;*/\n  color: white;\n}\n\n.video-overlay-text3fix {\n  position: absolute;\n  text-align: center;\n  top: 20%;\n  left: 65%;\n  width: 350px;\n  height: 20%;\n  /*display: flex;\n  justify-content: center;\n  align-items: center;*/\n  color: white;\n}\n\n.video-overlay-text5 {\n  position: absolute;\n  top: 27%;\n  left: 65%;\n  width: 400px;\n  height: 300px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n}\n\n.video-overlay-text5fix {\n  position: absolute;\n  top: 27%;\n  left: 65%;\n  width: 400px;\n  height: 300px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n}\n\n.video-overlay-text4 {\n  position: absolute;\n  top: 10%;\n  left: 5%;\n  width: 450px;\n  height: 20%;\n  /*display: flex;*/\n  /*justify-content: center;*/\n  /*align-items: center;*/\n  color: white;\n}\n\n.webForm {\n  display: block;\n}\n\n.mobileForm {\n  display: none;\n}\n\n@media screen and (max-width: 1200px) {\n  .video-overlay-text3 {\n    left: 50%;\n    transform: translate(-50%, -50%); \n  }\n  .video-overlay-text5{\n    left: 50%;\n    transform: translate(-50%, -50%);\n    top: 60%;\n    width: 350px;\n  }\n  .video-overlay-text4 {\n    top: 15%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 80%;\n \n  }\n}\n\n@media screen and (max-width: 768px) {\n  .video-overlay-text6{\n    display: block;\n    top: 5%\n  }\n  .video-overlay-text7{\n    top: 80%;\n    width: 80%\n  }\n  .certificate {\n   padding: 0 32px; \n  }\n  .video-overlay3{\n    background-color: rgba(0, 0, 0, 0.7);\n  }\n}\n\n\n\n\n\n.overlay-text-leftTop {\n  position: absolute;\n  top: 20%;\n  left: 5%;\n  width: 100%;\n  /*height: 20%;*/\n  /*display: flex;*/\n  /*justify-content: center;*/\n  /*align-items: center;*/\n  color: white;\n}\n\n.overlay-text-leftBottom {\n  position: absolute;\n  top: 60%;\n  left: 7%;\n  width: 100%;\n  /*height: 20%;*/\n  /*display: flex;*/\n  /*justify-content: center;*/\n  /*align-items: center;*/\n  color: white;\n}\n\n.overlay-text-leftBottom2 {\n  position: absolute;\n  top: 50%;\n  left: 7%;\n  width: 100%;\n  /*height: 20%;*/\n  /*display: flex;*/\n  /*justify-content: center;*/\n  /*align-items: center;*/\n  color: white;\n}\n\n.overlay-text-leftBottom2_product {\n  position: absolute;\n  top: 50%;\n  left: 7%;\n  width: 100%;\n  /*height: 20%;*/\n  /*display: flex;*/\n  /*justify-content: center;*/\n  /*align-items: center;*/\n  color: white;\n}\n\n.overlay-text-rightTop {\n  position: absolute;\n  top: 20%;\n  left: 70%;\n  width: 25%;\n  /*height: 20%;*/\n  /*display: flex;*/\n  /*justify-content: center;*/\n  /*align-items: center;*/\n  color: white;\n}\n\n.overlay-text-rightTop_product {\n  position: absolute;\n  top: 20%;\n  left: 70%;\n  width: 25%;\n  /*height: 20%;*/\n  /*display: flex;*/\n  /*justify-content: center;*/\n  /*align-items: center;*/\n  color: white;\n}\n\n.overlay-text-rightBottom {\n  position: absolute;\n  top: 40%;\n  left: 65%;\n  width: 400px;\n  /*height: 20%;*/\n  /*display: flex;*/\n  /*justify-content: center;*/\n  /*align-items: center;*/\n  color: white;\n}\n\n@media screen and (max-width: 1200px) {\n  .overlay-text-leftTop{\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 350px; \n  }\n  .overlay-text-rightBottom {\n    top: 60%;\n    left: 50%;\n    width: 350px;\n    transform: translate(-50%, -50%);\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .mobileFontSize{\n    font-size: 16px;\n  }\n  .product01{\n    padding: 50px 20px;\n  }\n  .overlay-text-leftBottom2_product{\n    left: 50%;\n    transform: translate(-50%, -50%);\n    top: 15%;\n    width: 80%; \n  }\n  .overlay-text-rightTop_product{\n    left: 50%;\n    transform: translate(-50%, -50%);\n    top: 50%;\n    width: 80%; \n  }\n}\n\n.container1 {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n}\n\n.item {\n  flex: 1;\n  min-width: 300px; /* 設置每個Col的最小寬度 */\n  padding: 10px;\n  box-sizing: border-box; /* 讓padding不影響元素的寬度 */\n}\n\n/* 使用媒體查詢來控制不同屏幕尺寸下的列數 */\n@media screen and (max-width: 767px) {\n  .item {\n    flex-basis: 100%; /* 在小屏幕下每個Col佔滿一行 */\n  }\n  .ProductCarousel1{\n    margin-bottom: 28px;\n  }\n  .Contact2{\n    padding: 32px 0;\n  }\n  .webForm{\n    display: none;\n  }\n  .mobileForm{\n    display: block;\n  }\n}\n\n@media screen and (min-width: 768px) and (max-width: 1199px) {\n  .item {\n    flex-basis: 50%; /* 在中屏幕下每個Col佔據一行的一半 */\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .Home1 {\n    padding: 150px 0 120px 0;\n  }\n  .Contact2 {\n    padding: 100px 0\n  }\n}\n\n@media screen and (min-width: 1200px) {\n  .container1{\n    margin: 150px 0px;\n    padding: 0 5%;\n  }\n  .item {\n    flex-basis: 25%; /* 在大屏幕下每個Col佔據一行的三分之一 */\n  }\n  .Contact1{\n    padding: 0 96px 0 0;\n  }\n}\n\n.fullscreen-bg {\n  position: relative;\n  /*width: 100vw;*/\n  height: 100vh;\n  overflow: hidden;\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.fullscreen-bg2 {\n  position: relative;\n  /*width: 100vw;*/\n  height: 100vh;\n  overflow: hidden;\n  background-color: rgba(0, 0, 0, 0.2); /* 半透明的黑色遮罩 */\n}\n\n/*.bg-image {\n  background-image: url(\"product/product2.jpg\");\n  background-size: cover;\n  background-position: center;\n  height: 75vh; /* 占据屏幕高度的一半 \n  display: flex;\n  align-items: center;\n  justify-content: center;\n}*/\n\n/* 設定背景圖片的樣式 */\n.fullscreen-bg img {\n /* position: absolute;*/\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover; /* 確保圖片充滿整個容器 */\n}\n\n/* 設定上方顯示文字的樣式 */\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  text-align: center;\n  background-color: rgba(0, 0, 0, 0.2); /* 可以使用透明背景來提高文字可讀性 */\n}\n\n.footer {\n  background-color: rgb(53, 53, 53);\n  padding: 50px 10%;\n}\n\n\n.headbottom {\n  height: 36px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  box-shadow: 2px 2px 4px 4px rgba(0, 0, 0, 0.2);\n  background-color: rgba(240, 142, 31, 0.8);\n  z-index: 1004;\n  text-align: center;\n  .totext {\n    font-weight: bolder;\n    line-height: 36px;\n    padding: 0 20px;\n    margin: 0 auto;\n    font-size: 15px;\n    color: white;\n  }\n}\n\n\n\n\n.item img {\n  width: 100%; /* 让图片宽度占满父容器 */\n  height: auto; /* 让高度根据宽度自适应，防止图片变形 */\n  display: block; /* 移除图片默认的间距，确保图片紧贴容器边缘 */\n}\n\n.text-center-container {\n  display: flex;\n  justify-content: center; /* 水平居中 */\n  align-items: center; /* 垂直居中 */\n  width: 100%; /* 容器宽度，可以根据需要调整 */\n  height: 180px; /*容器高度，可以根据需要调整 */\n}\n\n.extra-background {\n  background-color: rgba(0, 0, 0, 0.8); /* 额外背景的颜色 */\n  height: 0; /* 隐藏额外背景 */\n  position: fixed;\n  /*top: 60px;  这里根据顶部导航栏的高度来调整 */\n  left: 0;\n  right: 0;\n  z-index: 999; /* 确保在顶部导航栏下方但仍在其他内容之上 */\n  transition: height 0.3s; /* 添加过渡效果 */\n}\n\n.certificate-panel:hover{\nbackground-color: #ECECEB;\n}\n\n.certificate h5{\n  font-family: 'Noto Sans TC Medium';\n}\n\n.certificate a{\n  font-size: 12px;\n  height: 18px;\n  font-family: 'Noto Sans TC Medium';\n  text-decoration: none;\n}\n\n.certificate a:hover{\n  text-decoration: underline;\n}\n\n.transparent-button {\n  background-color: transparent; /* 設置按鈕的背景色為透明 */\n  border: 2px solid #9f9f9f; /* 設置按鈕的邊框 */\n  color: #FFFFFF; /* 設置按鈕文字顏色 */\n  padding: 3px 20px; /* 設置按鈕的內邊距 */\n  font-size: 22px; /* 設置按鈕文字大小 */\n  border-radius: 5px; /* 設置按鈕的圓角 */\n  cursor: pointer; /* 變更滑鼠游標類型為指示器 */\n  width: 300px;\n  font-family:'Noto Sans TC Regular';\n  z-index: 10000;\n}\n\n.Product2 {\n  background-color: white;\n}\n\n.transparent-button4 {\n  background-color: transparent; /* 設置按鈕的背景色為透明 */\n  border: 2px solid #9f9f9f; /* 設置按鈕的邊框 */\n  color: #FFFFFF; /* 設置按鈕文字顏色 */\n  padding: 3px 20px; /* 設置按鈕的內邊距 */\n  font-size: 22px; /* 設置按鈕文字大小 */\n  border-radius: 5px; /* 設置按鈕的圓角 */\n  cursor: pointer; /* 變更滑鼠游標類型為指示器 */\n  width: 300px;\n  font-family:'Noto Sans TC Regular';\n  z-index: 10000;\n}\n\n@media screen and (max-width: 768px) {\n  .transparent-button{\n    width: 300px;\n  }\n  .transparent-button4{\n    width: 180px;\n  }\n  .text-center-container{\n    height: 70px;\n    padding: 0 10px;\n  }\n  .Product2{\n    background-color: #ECECEB;\n  }\n}\n\n/* 鼠標懸停時的效果 */\n.transparent-button:hover {\n  background-color: #FFFFFF; /* 透明度設為0.2的淺灰色 */\n  color: #757679; /* 文字顏色設置為白色 */\n}\n\n/* 鼠標懸停時的效果 */\n.transparent-button4:hover {\n  background-color: #FFFFFF; /* 透明度設為0.2的淺灰色 */\n  color: #757679; /* 文字顏色設置為白色 */\n}\n\n.transparent-button2 {\n  background-color: white; /* 設置按鈕的背景色為透明 */\n  border: 2px solid white; /* 設置按鈕的邊框 */\n  color: black; /* 設置按鈕文字顏色 */\n  padding: 5px 20px; /* 設置按鈕的內邊距 */\n  font-size: 14px; /* 設置按鈕文字大小 */\n  border-radius: 2px; /* 設置按鈕的圓角 */\n  cursor: pointer; /* 變更滑鼠游標類型為指示器 */\n  width: 190px;\n  font-family:'Noto Sans TC Regular';\n  z-index: 10000;\n}\n\n.transparent-button3 {\n  background-color: transparent; /* 設置按鈕的背景色為透明 */\n  border: 2px solid white; /* 設置按鈕的邊框 */\n  color: black; /* 設置按鈕文字顏色 */\n  padding: 7px 20px; /* 設置按鈕的內邊距 */\n  font-size: 14px; /* 設置按鈕文字大小 */\n  border-radius: 2px; /* 設置按鈕的圓角 */\n  cursor: pointer; /* 變更滑鼠游標類型為指示器 */\n  width: 190px;\n  font-family:'Noto Sans TC Regular';\n  z-index: 10000;\n}\n\n.transparent-button3:hover{\n  background-color: #FEC30A;\n  border-color: #FEC30A;\n}\n\n.transparent-button3:focus{\n  background-color: #FEC30A;\n  border-color: #FEC30A;\n}\n\n/* 修改 Carousel 转场按钮（prev 和 next）的颜色 */\n.carousel-control-prev,\n.carousel-control-next {\n  color: #808080; /* 替换为您想要的颜色 */\n}\n\n/* 修改 Carousel 指示符（键号）激活状态的颜色 */\n.carousel-indicators .active {\n  background-color: #808080; /* 替换为您想要的激活状态的颜色 */\n}\n\n.english_FontFamily {\n  font-family: 'Exo VariableFont wght';\n  font-weight: 500;\n}\n\n.english_FontFamily2 {\n  font-family: 'Orbitron VariableFont wght';\n  font-weight: 500;\n}\n\n.mobile-nav {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #333; /* 设置背景颜色 */\n  color: #fff; /* 设置文字颜色 */\n  /*padding: 10px 20px;*/\n}\n\n.mobile-nav-icon {\n  cursor: pointer;\n  font-size: 24px;\n}\n\n.mobile-nav-links {\n  display: none; /* 初始状态下隐藏导航链接 */\n}\n\n@media (max-width: 768px) {\n  .mobile-nav-links {\n    display: block; /* 在小屏幕下显示导航链接 */\n    position: absolute;\n    top: 60px; /* 调整展开后的位置 */\n    left: 0;\n    background-color: #333;\n    width: 100%;\n    padding: 10px 20px;\n  }\n}\n\n.header {\n  display: none;\n}\n\n@media (min-width: 768px) {\n  .header {\n    display: block; /* 在大于或等于 768px 的屏幕宽度下显示Header */\n  }\n}\n\n.mobile_header{\n  display: none;\n}\n\n.showOnMobile {\n  display: none;\n}\n\n.center_container {\n  display: flex;\n  justify-content: center; /* 水平居中 */\n  align-items: center; /* 垂直居中 */\n  width: 100%; /* 使容器占据父元素的宽度 */\n}\n\n@media (max-width: 768px) {\n  .mobile_header {\n    display: block; /* 在大于或等于 768px 的屏幕宽度下显示Header */\n  }\n  .app-logo{\n    left: 50%;\n    transform: translate(-50%, -50%); \n    top: 28px; \n }\n .showOnMobile{\n    display: flex;\n    justify-content: center; /* 水平居中 */\n    align-items: center; /* 垂直居中 */\n    width: 100%; /* 使容器占据父元素的宽度 */\n    height: 72px;\n }\n}\n\n.fixed-Icon {\n  position: fixed; /* 固定定位 */\n  top: 0; /* 距离顶部的距离为 0 */\n  right: 0; /* 距离右侧的距离为 0 */\n  font-size: 60px;\n  padding: 10px;\n  color: white;\n}\n\n/* Style for the right drawer container */\n.right-drawer {\n  position: fixed; /* Fixed position to keep it in view */\n  top: 0;\n  right: -90%; /* Initially off-screen to the right */\n  width: 90%; /* Adjust the width as needed */\n  height: 100%; /* Take up the full height of the viewport */\n  background-color: #e5e5e5; /* Background color of the drawer */\n  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.3); /* Add a shadow for depth */\n  transition: right 0.3s ease; /* Smooth transition for opening/closing */\n  z-index: 999; /* Ensure it's above other content */\n}\n\n/* Style for the button to open the drawer */\n.open-drawer-button {\n  position: absolute; /* Position it anywhere you like */\n  top: 20px;\n  right: 20px;\n  background-color: #007bff;\n  color: #fff;\n  padding: 10px 20px;\n  border: none;\n  cursor: pointer;\n}\n\n/* Style for the content inside the drawer */\n.drawer-content {\n  padding: 20px;\n}\n\n/* Class to open the right drawer */\n.open {\n  right: 0;\n}\n\n.submitBtn {\n  background-color: #FCB208;\n}\n\n.submitBtn:hover {\n  background-color: #EFAA00;\n}\n\n.contacttext {\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\n  max-width: 60%;\n  line-height: 1.7;\n  text-align: center;\n  @media (max-width: 768px) {\n    max-width: 88%;\n  }\n}\n\n.image-company {\n  display: none;\n  @media (max-width: 768px) {\n    display: block;\n    img {\n      max-width: 100%;\n      padding-bottom: 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
